import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ada5f2f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kehucontainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "bottomDownload"
}
const _hoisted_5 = { class: "leftcon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "titleCon" }
const _hoisted_8 = { style: {"font-size":"15px","font-weight":"bold"} }
const _hoisted_9 = { style: {"font-size":"10px"} }
const _hoisted_10 = { class: "rightcon" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "maskClass"
}
const _hoisted_13 = { class: "centerViewClass" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { style: {"color":"white","font-size":"18px","font-weight":"600"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!
  const _directive_drag = _resolveDirective("drag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createCommentVNode(" 轮播图 "),
      _createVNode($setup["Swiper"]),
      _createCommentVNode(" 今天热门比赛 "),
      _createVNode($setup["Populartoday"], {
        ref: "Populartodays",
        onGetalldata: $setup.editConfirm,
        onTabscr: $setup.tabscr,
        onJumpToSport: _cache[0] || (_cache[0] = ($event: any) => ($setup.onNavTab(1))),
        categoryType: $setup.homeCategoryType_vi
      }, null, 8 /* PROPS */, ["categoryType"])
    ]),
    _createVNode($setup["TopNav"], {
      logo: $setup.logo,
      defaultActive: $setup.defaultActive,
      fadeDistance: 80,
      "onUpdate:activeIndex": $setup.onNavTab,
      onSearch: $setup.onSearch,
      class: "top_nav_class",
      homeTabs: $props.homeTabs
    }, null, 8 /* PROPS */, ["logo", "defaultActive", "homeTabs"]),
    _createCommentVNode(" 客服 "),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        style: _normalizeStyle({ left: $setup.screen.clientWidth - 70 + 'px', top: $setup.screen.clientHeight / 2 + 'px', position: 'fixed' })
      }, [
        _createElementVNode("img", {
          class: "kehuIcon",
          src: $setup.kehu_icon,
          alt: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onKehuClick()))
        }, null, 8 /* PROPS */, _hoisted_2),
        _createElementVNode("img", {
          class: "play_off_btn",
          src: $setup.play_off_btn,
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showKehu = false))
        }, null, 8 /* PROPS */, _hoisted_3)
      ], 4 /* STYLE */)), [
        [_vShow, true],
        [_directive_drag]
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, $setup.showKehu]
    ]),
    _createCommentVNode(" 底部的浮窗下载app "),
    ($setup.showDownApp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", { src: $setup.downLogo }, null, 8 /* PROPS */, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('home.qwzk')), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('home.lggg')), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "btn",
              style: _normalizeStyle({ backgroundColor: $setup.activeColor, color: $setup.activeFontColor }),
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.toDownloadApp()))
            }, _toDisplayString(_ctx.$t('home.downapp')), 5 /* TEXT, STYLE */),
            _createElementVNode("img", {
              class: "close",
              src: $setup.close_icon,
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showDownApp = false))
            }, null, 8 /* PROPS */, _hoisted_11)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 活动广告弹窗 "),
    ($setup.showActiveAlertView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              src: $setup.activeObj.cover
            }, null, 8 /* PROPS */, _hoisted_14),
            _createElementVNode("img", {
              src: $setup.activeCloseIcon,
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.closeActive()))
            }, null, 8 /* PROPS */, _hoisted_15)
          ]),
          _createVNode(_component_van_button, {
            style: {"margin-top":"24px","width":"160px","height":"45px","border-style":"none","background":"linear-gradient(to bottom, rgba(255, 119, 83, 1), rgba(242, 66, 24, 1))"},
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.onActivityClick($setup.activeObj))),
            round: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('立即参与')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}